/**
 * Search-params chokepoint wrapping react-router useSearchParams.
 */

import { useMemo } from "react";
import { useSearchParams as useRouterSearchParams } from "react-router";

/** Readonly URLSearchParams for the current location (react-router). */
export function useAppSearchParams(): URLSearchParams {
  const [params] = useRouterSearchParams();
  return useMemo(() => new URLSearchParams(params), [params]);
}
